import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    user: { 'type': 0, 'code': '', 'name': '', 'dept': '', 'company': { 'code': 0, 'name': '', 'street': '', 'city': '', 'pincode': '', 'state_cd': 33, 'gstin': '', 'email': '' }, 'branch': { 'code': 0, 'type': 0, 'name': '', 'street': '', 'city': '', 'pincode': '', 'state_cd': 33 }, 'working_date': '0001-01-01', 'year_from': '0001-01-01', 'year_upto': '0001-01-01', 'finyear': 2019, 'entry_from': '0001-01-01', 'entry_upto': '0001-01-01' },
    token: ''
  },
  actions: {
    login () {
      console.log('store->state->login')
    }
  },
  mutations: {
    change (state, user) {
      console.log('change')
      state.user = user
    }
  },
  getters: {
    user: state => state.user
  }
})
